<template>
    <span>
        <slot
            v-bind="{
                ...$data,

            }"
        />
    </span>
</template>

<script>
import ClipboardJS from 'clipboard';

export default {
    props: {
        element: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },

    },

    data: () => ({
        tooltipVisible: false,
        clipboardJs: null,
    }),

    /**
     * Created hook
     */
    created() {
        this.clipboardJs = new ClipboardJS(this.element, {
            target: (trigger) => {
                this.tooltipVisible = true;
                setTimeout(() => { this.tooltipVisible = false }, 1500);
            },
            text: (trigger) => this.value,
        });
    },

    /**
     * Before destroy hook
     */
    beforeDestroy() {
        this.clipboardJs.destroy();
    },
};
</script>
